<template>
    <div class="pagination">
      <button
        v-for="page in pages"
        :key="page"
        :class="{ active: page === current }"
        @click="$emit('change', page)"
      >
        {{ page }}
      </button>
  
      <button
        :disabled="current === pages.length"
        @click="$emit('next')"
      >
        Next
      </button>

    </div>
  </template>
  
  <script>
  export default {
    name: "PaginationComponent",
    props: {
      current: Number,
      pages: Array
    }
  };
  </script>
  
  <style scoped>
  .pagination {
    display: flex;
    gap: 8px;
    justify-content: center;
    margin: 30px 0;
  }
  
  button {
    background: transparent;
    border: 1px solid #444;
    color: #fff;
    padding: 6px 12px;
    border-radius: 6px;
  }
  
  button.active {
    background: #ff4f8b;
    border-color: #ff4f8b;
  }
  button:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }

  </style>
  